import {
  Box,
  List,
  ListItem,
  ListItemText,
  Stack,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import {TrendingFlat} from '@mui/icons-material';
import {iTimedMsgDateRange} from '../TimedMessageRequest';
import TimedMsgRequestReviewDayTimes from './TimedMsgRequestReviewDayTimes';

type Props = {
  type: string;
  ranges: iTimedMsgDateRange[];
};

const TimedMsgRequestReviewDates = ({type, ranges}: Props) => {
  return (
    <List disablePadding>
      {ranges.map(range => (
        <ListItem dense key={range.id} className='p-0'>
          <ListItemText
            id='dateValue'
            primaryTypographyProps={{
              sx: {display: 'flex', alignItems: 'center'},
            }}>
            {range.start_date?.format('MM/DD/YYYY')}
            {type === 'multiple' ? (
              <>
                {' '}
                <TrendingFlat /> {range.end_date?.format('MM/DD/YYYY')}
              </>
            ) : (
              ''
            )}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
};
export default TimedMsgRequestReviewDates;

export const TimedMsgRequestReviewMultipleDates = ({
  ranges,
}: {
  ranges: iTimedMsgDateRange[];
}) => {
  return (
    <List disablePadding>
      {ranges.map(range => (
        <ListItem dense key={range.id} className='p-0'>
          <Box className='mb-2'>
            <Stack
              id='dateValue'
              className='font-bold'
              direction='row'
              alignContent='center'
              alignItems='center'
              width='100%'
              spacing={1}>
              {range.start_date?.format('MM/DD/YYYY')} <TrendingFlat />{' '}
              {range.end_date?.format('MM/DD/YYYY')}
            </Stack>
            {range?.day_times ? (
              <TableBody>
                <TableRow>
                  <TableCell className='text-white-50 text-16 w-150'>
                    Day & Time(s)
                  </TableCell>
                  <TableCell>
                    <TimedMsgRequestReviewDayTimes items={range?.day_times} />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : null}
          </Box>
        </ListItem>
      ))}
    </List>
  );
};
